import React from 'react';
import checkPermission from '../../../utils/permissions/permissions';
import PageNotFound from './pageNotFount';

interface IPermissionsProviderProps {
  children: React.ReactNode;
  pageId: string
}

const PermissionsProvider = ({
  children,
  pageId,
}: IPermissionsProviderProps): JSX.Element => {
  let hasPermission = false;
  pageId.split(',').forEach((page) => {
    if (checkPermission(page, 'read') || hasPermission) {
      hasPermission = true;
    }
  });
  return !hasPermission ? <PageNotFound /> : (
    <>
      { children }
    </>
  );
};

PermissionsProvider.displayName = 'PermissionsProvider';

export default PermissionsProvider;
